import { toFirstDayOfMonthDate } from '../../constants/date';

export const convertProductValues = (values, valueKey, year) => {
  return values.map((monthly) => {
    return {
      /**
       * BE returns month indexes offset by 1
       */
      x: toFirstDayOfMonthDate(year, monthly.month - 1),
      y: monthly[valueKey],
      color: monthly?.color || undefined,
    };
  });
};

export const convertToChartData = (data, year) => {
  const graphData = {};
  data.forEach((product) => {
    graphData[product.productType] = convertProductValues(product.quantities, 'quantity', year);
  });
  return graphData;
};
